import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ReturnMessage } from '../models/return-message';
import { XoiJobInfo } from '../models/xoi/xoi-job-info';
import { XoiJobInfoPayload } from '../models/xoi/xoi-job-info-payload';

@Injectable({
  providedIn: 'root'
})
export class XoiService {

  private apis = {
    createXoiJobAndJobShare: 'XoiIntegration/CreateXoiJobAndJobShare/',
  };

  constructor(private http: HttpClient) { }

  createXoiJobAndJobShare(id: number): Observable<ReturnMessage<XoiJobInfoPayload>> {
    return this.http.post<ReturnMessage<XoiJobInfoPayload>>(this.apis.createXoiJobAndJobShare, id);
  }
}
